import React from 'react'
import { NewAppLayout } from '@/components/new-ux/layout/NewAppLayout'
import { SmartleadDiscoveryDashboard } from '@/components/smartlead-sync/SmartleadDiscoveryDashboard'

export default function SmartleadDiscoveryPage() {
  return (
    <NewAppLayout fullWidth>
      <SmartleadDiscoveryDashboard />
    </NewAppLayout>
  )
}
